import { FC } from 'react';
import styled from 'styled-components';

import Text from '@/components/Text';
import { VideoCompilerYoutubeVideo } from '@/types/resources';

const Grid = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const Row = styled.div`
  display: flex;
  gap: 6px;
  align-items: flex-start;
`;

const Thumb = styled.img`
  width: 16px;
  height: 16px;
  object-fit: cover;
  border-radius: 50%;
`;

const Status = styled(Text)`
  text-transform: capitalize;
`;

interface Props {
  videos: VideoCompilerYoutubeVideo[];
}

const CompilationYoutubeVideos: FC<Props> = ({ videos }) => {
  if (!videos.length) {
    return <>-</>;
  }

  return (
    <Grid>
      {videos.map(({ externalId, channel, status }) => (
        <Row key={externalId}>
          {!!channel.thumbnail && (
            <Thumb loading="lazy" src={channel.thumbnail} alt="" />
          )}
          <div>
            {channel.name}
            {status !== 'completed' && (
              <>
                <br />
                <Status as="span" $type="extraSmall" $color="gray">
                  {status}
                </Status>
              </>
            )}
          </div>
        </Row>
      ))}
    </Grid>
  );
};

export default CompilationYoutubeVideos;
